import React from 'react'
import './Technologies.css'
import { useScrollReveal } from '../../hooks/useScrollReveal'
import { useTilt } from '../../hooks/useTilt'
import { useScrollZoom } from '../../hooks/useScrollZoom'

// Grounded in the real stack from experience.json across every job, not a
// wishlist  ordered so the technologies that show up again and again lead
// each category.
const techCategories = [
  {
    key: 'front-end',
    techs: [
      'React.js',
      'JavaScript',
      'TypeScript',
      'Next.js',
      'React Native',
      'Expo',
      'Flutter',
      'HTML5',
      'CSS3',
    ],
  },
  {
    key: 'back-end',
    techs: ['Node.js', 'PHP', 'Laravel', 'Python', 'REST APIs', 'Delphi', 'Java'],
  },
  {
    key: 'banco-de-dados',
    techs: ['MySQL', 'MongoDB', 'PostgreSQL', 'Firebird'],
  },
  {
    key: 'devops-cloud',
    techs: ['Git', 'AWS', 'Docker', 'CI/CD'],
  },
  {
    key: 'workflow',
    techs: ['Notion', 'Linear', 'ClickUp', 'Figma', 'Postman', 'Jira'],
  },
]

const TechCategoryBlock = ({ category, isLast }) => {
  const tiltRef = useTilt({ max: 3, scale: 1.01 })
  const zoomRef = useScrollZoom()

  return (
    <div className="tech-category-zoom" data-reveal-item ref={zoomRef}>
      <div className="tech-category-block" ref={tiltRef}>
        <p className="tech-category-key">
          <span className="tok-str">"{category.key}"</span>: [
        </p>
        <div className="tech-tags">
          {category.techs.map((tech) => (
            <span className="tech-tag" key={tech}>
              {tech}
            </span>
          ))}
        </div>
        <p className="tech-category-close">]{isLast ? '' : ','}</p>
      </div>
    </div>
  )
}

const Technologies = () => {
  const revealRef = useScrollReveal({ y: 25, stagger: 0.1 })

  return (
    <div className="file-card technologies-wrapper">
      <div className="file-card-bar">
        <span className="file-card-dot" aria-hidden="true" />
        stack.json
      </div>
      <div className="file-card-body">
        <p className="tech-comment">
          {'// full-stack há 10+ anos: web, mobile e sistemas legados  o que o projeto pedir'}
        </p>
        <p className="tech-brace">{'{'}</p>
        <div className="tech-categories" ref={revealRef}>
          {techCategories.map((cat, i) => (
            <TechCategoryBlock
              category={cat}
              key={cat.key}
              isLast={i === techCategories.length - 1}
            />
          ))}
        </div>
        <p className="tech-brace">{'}'}</p>
      </div>
    </div>
  )
}

export default Technologies
